export default "__VITE_ASSET__BGoXhI5$__"